import React, {Component} from 'react'

class Message extends Component {
    render() {
            let id = "";

            if ('type' in this.props){
                const idTags = {
                    success: "successMessage",
                    error: "errorMessage",
                    warning: "warningMessage"
                }

                id = idTags[this.props.type]
            }

            let body = null;

            if ('body' in this.props){
                body = <div className="messageBody">{this.props.body}</div>
            }

            return (
                <div className="message" id={id}>
                    <div className="messageHeader">
                        <div>
                            <h3>{this.props.message}</h3>
                        </div>
                        <div>

                        </div>
                    </div>
                    {body}
                </div>
            )
    }
}

export default Message